export const sidebar = {
    "v": "5.9.6",
    "fr": 60,
    "ip": 0,
    "op": 120,
    "w": 750,
    "h": 750,
    "nm": "Main render",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 4,
            "nm": "Layer 3",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        375,
                        375,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        375,
                        375,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "t": 10,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -244.235,
                                                        104.77600000000001
                                                    ],
                                                    [
                                                        -243.809,
                                                        105.028
                                                    ],
                                                    [
                                                        -223.662,
                                                        105.382
                                                    ],
                                                    [
                                                        199.662,
                                                        105.382
                                                    ],
                                                    [
                                                        244.662,
                                                        105.223
                                                    ],
                                                    [
                                                        244.235,
                                                        104.971
                                                    ],
                                                    [
                                                        224.08800000000002,
                                                        104.618
                                                    ],
                                                    [
                                                        -199.235,
                                                        104.618
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -244.235,
                                                        104.971
                                                    ],
                                                    [
                                                        -243.809,
                                                        105.223
                                                    ],
                                                    [
                                                        -198.809,
                                                        105.382
                                                    ],
                                                    [
                                                        224.51500000000001,
                                                        105.382
                                                    ],
                                                    [
                                                        244.662,
                                                        105.028
                                                    ],
                                                    [
                                                        244.235,
                                                        104.77600000000001
                                                    ],
                                                    [
                                                        199.235,
                                                        104.618
                                                    ],
                                                    [
                                                        -224.08800000000002,
                                                        104.618
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -244.235,
                                                        104.971
                                                    ],
                                                    [
                                                        -243.809,
                                                        105.028
                                                    ],
                                                    [
                                                        -198.809,
                                                        105.382
                                                    ],
                                                    [
                                                        199.662,
                                                        105.382
                                                    ],
                                                    [
                                                        244.662,
                                                        105.028
                                                    ],
                                                    [
                                                        244.235,
                                                        104.971
                                                    ],
                                                    [
                                                        199.235,
                                                        104.618
                                                    ],
                                                    [
                                                        -199.235,
                                                        104.618
                                                    ]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "t": 20,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -244.235,
                                                        84.471
                                                    ],
                                                    [
                                                        -243.809,
                                                        54.382
                                                    ],
                                                    [
                                                        -223.662,
                                                        9.382
                                                    ],
                                                    [
                                                        199.662,
                                                        9.382
                                                    ],
                                                    [
                                                        244.662,
                                                        29.528999999999996
                                                    ],
                                                    [
                                                        244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        224.08800000000002,
                                                        104.618
                                                    ],
                                                    [
                                                        -199.235,
                                                        104.618
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        -243.809,
                                                        29.528999999999996
                                                    ],
                                                    [
                                                        -198.809,
                                                        9.382
                                                    ],
                                                    [
                                                        224.51500000000001,
                                                        9.382
                                                    ],
                                                    [
                                                        244.662,
                                                        54.382
                                                    ],
                                                    [
                                                        244.235,
                                                        84.471
                                                    ],
                                                    [
                                                        199.235,
                                                        104.618
                                                    ],
                                                    [
                                                        -224.08800000000002,
                                                        104.618
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        -243.809,
                                                        54.382
                                                    ],
                                                    [
                                                        -198.809,
                                                        9.382
                                                    ],
                                                    [
                                                        199.662,
                                                        9.382
                                                    ],
                                                    [
                                                        244.662,
                                                        54.382
                                                    ],
                                                    [
                                                        244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        199.235,
                                                        104.618
                                                    ],
                                                    [
                                                        -199.235,
                                                        104.618
                                                    ]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 30,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -244.235,
                                                        84.471
                                                    ],
                                                    [
                                                        -243.471,
                                                        -111.618
                                                    ],
                                                    [
                                                        -223.324,
                                                        -156.618
                                                    ],
                                                    [
                                                        200,
                                                        -156.618
                                                    ],
                                                    [
                                                        245,
                                                        -136.471
                                                    ],
                                                    [
                                                        244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        224.08800000000002,
                                                        104.618
                                                    ],
                                                    [
                                                        -199.235,
                                                        104.618
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        -243.471,
                                                        -136.471
                                                    ],
                                                    [
                                                        -198.471,
                                                        -156.618
                                                    ],
                                                    [
                                                        224.853,
                                                        -156.618
                                                    ],
                                                    [
                                                        245,
                                                        -111.618
                                                    ],
                                                    [
                                                        244.235,
                                                        84.471
                                                    ],
                                                    [
                                                        199.235,
                                                        104.618
                                                    ],
                                                    [
                                                        -224.08800000000002,
                                                        104.618
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        -243.471,
                                                        -111.618
                                                    ],
                                                    [
                                                        -198.471,
                                                        -156.618
                                                    ],
                                                    [
                                                        200,
                                                        -156.618
                                                    ],
                                                    [
                                                        245,
                                                        -111.618
                                                    ],
                                                    [
                                                        244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        199.235,
                                                        104.618
                                                    ],
                                                    [
                                                        -199.235,
                                                        104.618
                                                    ]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 40,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -244.235,
                                                        84.471
                                                    ],
                                                    [
                                                        -244.235,
                                                        -39.618
                                                    ],
                                                    [
                                                        -224.08800000000002,
                                                        -84.618
                                                    ],
                                                    [
                                                        199.235,
                                                        -84.618
                                                    ],
                                                    [
                                                        244.235,
                                                        -64.471
                                                    ],
                                                    [
                                                        244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        224.08800000000002,
                                                        104.618
                                                    ],
                                                    [
                                                        -199.235,
                                                        104.618
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        -244.235,
                                                        -64.471
                                                    ],
                                                    [
                                                        -199.235,
                                                        -84.618
                                                    ],
                                                    [
                                                        224.08800000000002,
                                                        -84.618
                                                    ],
                                                    [
                                                        244.235,
                                                        -39.618
                                                    ],
                                                    [
                                                        244.235,
                                                        84.471
                                                    ],
                                                    [
                                                        199.235,
                                                        104.618
                                                    ],
                                                    [
                                                        -224.08800000000002,
                                                        104.618
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        -244.235,
                                                        -39.618
                                                    ],
                                                    [
                                                        -199.235,
                                                        -84.618
                                                    ],
                                                    [
                                                        199.235,
                                                        -84.618
                                                    ],
                                                    [
                                                        244.235,
                                                        -39.618
                                                    ],
                                                    [
                                                        244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        199.235,
                                                        104.618
                                                    ],
                                                    [
                                                        -199.235,
                                                        104.618
                                                    ]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 50,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -244.235,
                                                        84.471
                                                    ],
                                                    [
                                                        -244.235,
                                                        -59.618
                                                    ],
                                                    [
                                                        -224.08800000000002,
                                                        -104.618
                                                    ],
                                                    [
                                                        199.235,
                                                        -104.618
                                                    ],
                                                    [
                                                        244.235,
                                                        -84.471
                                                    ],
                                                    [
                                                        244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        224.08800000000002,
                                                        104.618
                                                    ],
                                                    [
                                                        -199.235,
                                                        104.618
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        -244.235,
                                                        -84.471
                                                    ],
                                                    [
                                                        -199.235,
                                                        -104.618
                                                    ],
                                                    [
                                                        224.08800000000002,
                                                        -104.618
                                                    ],
                                                    [
                                                        244.235,
                                                        -59.618
                                                    ],
                                                    [
                                                        244.235,
                                                        84.471
                                                    ],
                                                    [
                                                        199.235,
                                                        104.618
                                                    ],
                                                    [
                                                        -224.08800000000002,
                                                        104.618
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        -244.235,
                                                        -59.618
                                                    ],
                                                    [
                                                        -199.235,
                                                        -104.618
                                                    ],
                                                    [
                                                        199.235,
                                                        -104.618
                                                    ],
                                                    [
                                                        244.235,
                                                        -59.618
                                                    ],
                                                    [
                                                        244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        199.235,
                                                        104.618
                                                    ],
                                                    [
                                                        -199.235,
                                                        104.618
                                                    ]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 35,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    375,
                                    514.618
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "t": 10,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -243.617,
                                                        386.079
                                                    ],
                                                    [
                                                        -244.279,
                                                        388.078
                                                    ],
                                                    [
                                                        -226.456,
                                                        390.029
                                                    ],
                                                    [
                                                        204.383,
                                                        390.029
                                                    ],
                                                    [
                                                        244.191,
                                                        389.15599999999995
                                                    ],
                                                    [
                                                        244.853,
                                                        387.157
                                                    ],
                                                    [
                                                        227.03,
                                                        385.206
                                                    ],
                                                    [
                                                        -203.809,
                                                        385.206
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -243.617,
                                                        387.157
                                                    ],
                                                    [
                                                        -244.279,
                                                        389.15599999999995
                                                    ],
                                                    [
                                                        -204.47,
                                                        390.029
                                                    ],
                                                    [
                                                        226.369,
                                                        390.029
                                                    ],
                                                    [
                                                        244.191,
                                                        388.078
                                                    ],
                                                    [
                                                        244.853,
                                                        386.079
                                                    ],
                                                    [
                                                        205.044,
                                                        385.206
                                                    ],
                                                    [
                                                        -225.795,
                                                        385.206
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -243.617,
                                                        387.157
                                                    ],
                                                    [
                                                        -244.279,
                                                        388.078
                                                    ],
                                                    [
                                                        -204.47,
                                                        390.029
                                                    ],
                                                    [
                                                        204.383,
                                                        390.029
                                                    ],
                                                    [
                                                        244.191,
                                                        388.078
                                                    ],
                                                    [
                                                        244.853,
                                                        387.157
                                                    ],
                                                    [
                                                        205.044,
                                                        385.206
                                                    ],
                                                    [
                                                        -203.809,
                                                        385.206
                                                    ]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "t": 20,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -243.809,
                                                        201.38299999999998
                                                    ],
                                                    [
                                                        -244.235,
                                                        -65.397
                                                    ],
                                                    [
                                                        -226.41299999999998,
                                                        -105.206
                                                    ],
                                                    [
                                                        204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        244.235,
                                                        -87.38300000000001
                                                    ],
                                                    [
                                                        244.662,
                                                        179.397
                                                    ],
                                                    [
                                                        226.839,
                                                        219.206
                                                    ],
                                                    [
                                                        -204,
                                                        219.206
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -243.809,
                                                        179.397
                                                    ],
                                                    [
                                                        -244.235,
                                                        -87.38300000000001
                                                    ],
                                                    [
                                                        -204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        226.41299999999998,
                                                        -105.206
                                                    ],
                                                    [
                                                        244.235,
                                                        -65.397
                                                    ],
                                                    [
                                                        244.662,
                                                        201.38299999999998
                                                    ],
                                                    [
                                                        204.853,
                                                        219.206
                                                    ],
                                                    [
                                                        -225.986,
                                                        219.206
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -243.809,
                                                        179.397
                                                    ],
                                                    [
                                                        -244.235,
                                                        -65.397
                                                    ],
                                                    [
                                                        -204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        244.235,
                                                        -65.397
                                                    ],
                                                    [
                                                        244.662,
                                                        179.397
                                                    ],
                                                    [
                                                        204.853,
                                                        219.206
                                                    ],
                                                    [
                                                        -204,
                                                        219.206
                                                    ]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 30,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -243.471,
                                                        35.383
                                                    ],
                                                    [
                                                        -244.235,
                                                        -65.397
                                                    ],
                                                    [
                                                        -226.41299999999998,
                                                        -105.206
                                                    ],
                                                    [
                                                        204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        244.235,
                                                        -87.38300000000001
                                                    ],
                                                    [
                                                        245,
                                                        13.397
                                                    ],
                                                    [
                                                        227.177,
                                                        53.206
                                                    ],
                                                    [
                                                        -203.662,
                                                        53.206
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -243.471,
                                                        13.397
                                                    ],
                                                    [
                                                        -244.235,
                                                        -87.38300000000001
                                                    ],
                                                    [
                                                        -204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        226.41299999999998,
                                                        -105.206
                                                    ],
                                                    [
                                                        244.235,
                                                        -65.397
                                                    ],
                                                    [
                                                        245,
                                                        35.383
                                                    ],
                                                    [
                                                        205.191,
                                                        53.206
                                                    ],
                                                    [
                                                        -225.648,
                                                        53.206
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -243.471,
                                                        13.397
                                                    ],
                                                    [
                                                        -244.235,
                                                        -65.397
                                                    ],
                                                    [
                                                        -204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        244.235,
                                                        -65.397
                                                    ],
                                                    [
                                                        245,
                                                        13.397
                                                    ],
                                                    [
                                                        205.191,
                                                        53.206
                                                    ],
                                                    [
                                                        -203.662,
                                                        53.206
                                                    ]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.667,
                                            "y": 1
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 40,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -244.235,
                                                        107.38300000000001
                                                    ],
                                                    [
                                                        -244.235,
                                                        -65.397
                                                    ],
                                                    [
                                                        -226.41299999999998,
                                                        -105.206
                                                    ],
                                                    [
                                                        204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        244.235,
                                                        -87.38300000000001
                                                    ],
                                                    [
                                                        244.235,
                                                        85.397
                                                    ],
                                                    [
                                                        226.41299999999998,
                                                        125.206
                                                    ],
                                                    [
                                                        -204.427,
                                                        125.206
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -244.235,
                                                        85.397
                                                    ],
                                                    [
                                                        -244.235,
                                                        -87.38300000000001
                                                    ],
                                                    [
                                                        -204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        226.41299999999998,
                                                        -105.206
                                                    ],
                                                    [
                                                        244.235,
                                                        -65.397
                                                    ],
                                                    [
                                                        244.235,
                                                        107.38300000000001
                                                    ],
                                                    [
                                                        204.427,
                                                        125.206
                                                    ],
                                                    [
                                                        -226.41299999999998,
                                                        125.206
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -244.235,
                                                        85.397
                                                    ],
                                                    [
                                                        -244.235,
                                                        -65.397
                                                    ],
                                                    [
                                                        -204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        244.235,
                                                        -65.397
                                                    ],
                                                    [
                                                        244.235,
                                                        85.397
                                                    ],
                                                    [
                                                        204.427,
                                                        125.206
                                                    ],
                                                    [
                                                        -204.427,
                                                        125.206
                                                    ]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 50,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -244.235,
                                                        87.38300000000001
                                                    ],
                                                    [
                                                        -244.235,
                                                        -65.397
                                                    ],
                                                    [
                                                        -226.41299999999998,
                                                        -105.206
                                                    ],
                                                    [
                                                        204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        244.235,
                                                        -87.38300000000001
                                                    ],
                                                    [
                                                        244.235,
                                                        65.397
                                                    ],
                                                    [
                                                        226.41299999999998,
                                                        105.206
                                                    ],
                                                    [
                                                        -204.427,
                                                        105.206
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -244.235,
                                                        65.397
                                                    ],
                                                    [
                                                        -244.235,
                                                        -87.38300000000001
                                                    ],
                                                    [
                                                        -204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        226.41299999999998,
                                                        -105.206
                                                    ],
                                                    [
                                                        244.235,
                                                        -65.397
                                                    ],
                                                    [
                                                        244.235,
                                                        87.38300000000001
                                                    ],
                                                    [
                                                        204.427,
                                                        105.206
                                                    ],
                                                    [
                                                        -226.41299999999998,
                                                        105.206
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -244.235,
                                                        65.397
                                                    ],
                                                    [
                                                        -244.235,
                                                        -65.397
                                                    ],
                                                    [
                                                        -204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        244.235,
                                                        -65.397
                                                    ],
                                                    [
                                                        244.235,
                                                        65.397
                                                    ],
                                                    [
                                                        204.427,
                                                        105.206
                                                    ],
                                                    [
                                                        -204.427,
                                                        105.206
                                                    ]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 35,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    375,
                                    235.971
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                }
            ],
            "ip": 10,
            "op": 190,
            "st": 10,
            "ct": 1,
            "bm": 0,
            "completed": true
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Layer 2",
            "sr": 1,
            "ks": {
                "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 11
                },
                "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 10
                },
                "p": {
                    "a": 0,
                    "k": [
                        375,
                        375,
                        0
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": {
                    "a": 0,
                    "k": [
                        375,
                        375,
                        0
                    ],
                    "ix": 1,
                    "l": 2
                },
                "s": {
                    "a": 0,
                    "k": [
                        100,
                        100,
                        100
                    ],
                    "ix": 6,
                    "l": 2
                }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 0,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -244.235,
                                                        84.471
                                                    ],
                                                    [
                                                        -244.235,
                                                        -59.618
                                                    ],
                                                    [
                                                        -224.08800000000002,
                                                        -104.618
                                                    ],
                                                    [
                                                        199.235,
                                                        -104.618
                                                    ],
                                                    [
                                                        244.235,
                                                        -84.471
                                                    ],
                                                    [
                                                        244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        224.08800000000002,
                                                        104.618
                                                    ],
                                                    [
                                                        -199.235,
                                                        104.618
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        -244.235,
                                                        -84.471
                                                    ],
                                                    [
                                                        -199.235,
                                                        -104.618
                                                    ],
                                                    [
                                                        224.08800000000002,
                                                        -104.618
                                                    ],
                                                    [
                                                        244.235,
                                                        -59.618
                                                    ],
                                                    [
                                                        244.235,
                                                        84.471
                                                    ],
                                                    [
                                                        199.235,
                                                        104.618
                                                    ],
                                                    [
                                                        -224.08800000000002,
                                                        104.618
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        -244.235,
                                                        -59.618
                                                    ],
                                                    [
                                                        -199.235,
                                                        -104.618
                                                    ],
                                                    [
                                                        199.235,
                                                        -104.618
                                                    ],
                                                    [
                                                        244.235,
                                                        -59.618
                                                    ],
                                                    [
                                                        244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        199.235,
                                                        104.618
                                                    ],
                                                    [
                                                        -199.235,
                                                        104.618
                                                    ]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "o": {
                                            "x": 0.167,
                                            "y": 0.167
                                        },
                                        "t": 10,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -244.235,
                                                        84.471
                                                    ],
                                                    [
                                                        -243.941,
                                                        -337.618
                                                    ],
                                                    [
                                                        -223.79500000000002,
                                                        -382.618
                                                    ],
                                                    [
                                                        199.529,
                                                        -382.618
                                                    ],
                                                    [
                                                        244.529,
                                                        -362.471
                                                    ],
                                                    [
                                                        244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        224.08800000000002,
                                                        104.618
                                                    ],
                                                    [
                                                        -199.235,
                                                        104.618
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        -243.941,
                                                        -362.471
                                                    ],
                                                    [
                                                        -198.942,
                                                        -382.618
                                                    ],
                                                    [
                                                        224.382,
                                                        -382.618
                                                    ],
                                                    [
                                                        244.529,
                                                        -337.618
                                                    ],
                                                    [
                                                        244.235,
                                                        84.471
                                                    ],
                                                    [
                                                        199.235,
                                                        104.618
                                                    ],
                                                    [
                                                        -224.08800000000002,
                                                        104.618
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        -243.941,
                                                        -337.618
                                                    ],
                                                    [
                                                        -198.942,
                                                        -382.618
                                                    ],
                                                    [
                                                        199.529,
                                                        -382.618
                                                    ],
                                                    [
                                                        244.529,
                                                        -337.618
                                                    ],
                                                    [
                                                        244.235,
                                                        59.618
                                                    ],
                                                    [
                                                        199.235,
                                                        104.618
                                                    ],
                                                    [
                                                        -199.235,
                                                        104.618
                                                    ]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 20,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -245,
                                                        -381.041
                                                    ],
                                                    [
                                                        -243.941,
                                                        -381.673
                                                    ],
                                                    [
                                                        -223.79500000000002,
                                                        -382.618
                                                    ],
                                                    [
                                                        199.529,
                                                        -382.618
                                                    ],
                                                    [
                                                        244.529,
                                                        -382.195
                                                    ],
                                                    [
                                                        243.471,
                                                        -381.563
                                                    ],
                                                    [
                                                        223.324,
                                                        -380.618
                                                    ],
                                                    [
                                                        -200,
                                                        -380.618
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -245,
                                                        -381.563
                                                    ],
                                                    [
                                                        -243.941,
                                                        -382.195
                                                    ],
                                                    [
                                                        -198.942,
                                                        -382.618
                                                    ],
                                                    [
                                                        224.382,
                                                        -382.618
                                                    ],
                                                    [
                                                        244.529,
                                                        -381.673
                                                    ],
                                                    [
                                                        243.471,
                                                        -381.041
                                                    ],
                                                    [
                                                        198.471,
                                                        -380.618
                                                    ],
                                                    [
                                                        -224.853,
                                                        -380.618
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -245,
                                                        -381.563
                                                    ],
                                                    [
                                                        -243.941,
                                                        -381.673
                                                    ],
                                                    [
                                                        -198.942,
                                                        -382.618
                                                    ],
                                                    [
                                                        199.529,
                                                        -382.618
                                                    ],
                                                    [
                                                        244.529,
                                                        -381.673
                                                    ],
                                                    [
                                                        243.471,
                                                        -381.563
                                                    ],
                                                    [
                                                        198.471,
                                                        -380.618
                                                    ],
                                                    [
                                                        -200,
                                                        -380.618
                                                    ]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 35,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    375,
                                    514.618
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 1,
                                "k": [
                                    {
                                        "i": {
                                            "x": 0.833,
                                            "y": 0.833
                                        },
                                        "o": {
                                            "x": 0.333,
                                            "y": 0
                                        },
                                        "t": 0,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -244.235,
                                                        87.38300000000001
                                                    ],
                                                    [
                                                        -244.235,
                                                        -65.397
                                                    ],
                                                    [
                                                        -226.41299999999998,
                                                        -105.206
                                                    ],
                                                    [
                                                        204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        244.235,
                                                        -87.38300000000001
                                                    ],
                                                    [
                                                        244.235,
                                                        65.397
                                                    ],
                                                    [
                                                        226.41299999999998,
                                                        105.206
                                                    ],
                                                    [
                                                        -204.427,
                                                        105.206
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -244.235,
                                                        65.397
                                                    ],
                                                    [
                                                        -244.235,
                                                        -87.38300000000001
                                                    ],
                                                    [
                                                        -204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        226.41299999999998,
                                                        -105.206
                                                    ],
                                                    [
                                                        244.235,
                                                        -65.397
                                                    ],
                                                    [
                                                        244.235,
                                                        87.38300000000001
                                                    ],
                                                    [
                                                        204.427,
                                                        105.206
                                                    ],
                                                    [
                                                        -226.41299999999998,
                                                        105.206
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -244.235,
                                                        65.397
                                                    ],
                                                    [
                                                        -244.235,
                                                        -65.397
                                                    ],
                                                    [
                                                        -204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        244.235,
                                                        -65.397
                                                    ],
                                                    [
                                                        244.235,
                                                        65.397
                                                    ],
                                                    [
                                                        204.427,
                                                        105.206
                                                    ],
                                                    [
                                                        -204.427,
                                                        105.206
                                                    ]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    },
                                    {
                                        "t": 10,
                                        "s": [
                                            {
                                                "i": [
                                                    [
                                                        -243.471,
                                                        -102.65299999999999
                                                    ],
                                                    [
                                                        -244.235,
                                                        -103.68
                                                    ],
                                                    [
                                                        -226.41299999999998,
                                                        -105.206
                                                    ],
                                                    [
                                                        204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        244.235,
                                                        -104.52300000000001
                                                    ],
                                                    [
                                                        245,
                                                        -103.496
                                                    ],
                                                    [
                                                        227.177,
                                                        -101.971
                                                    ],
                                                    [
                                                        -203.662,
                                                        -101.971
                                                    ]
                                                ],
                                                "o": [
                                                    [
                                                        -243.471,
                                                        -103.496
                                                    ],
                                                    [
                                                        -244.235,
                                                        -104.52300000000001
                                                    ],
                                                    [
                                                        -204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        226.41299999999998,
                                                        -105.206
                                                    ],
                                                    [
                                                        244.235,
                                                        -103.68
                                                    ],
                                                    [
                                                        245,
                                                        -102.65299999999999
                                                    ],
                                                    [
                                                        205.191,
                                                        -101.971
                                                    ],
                                                    [
                                                        -225.648,
                                                        -101.971
                                                    ]
                                                ],
                                                "v": [
                                                    [
                                                        -243.471,
                                                        -103.496
                                                    ],
                                                    [
                                                        -244.235,
                                                        -103.68
                                                    ],
                                                    [
                                                        -204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        204.427,
                                                        -105.206
                                                    ],
                                                    [
                                                        244.235,
                                                        -103.68
                                                    ],
                                                    [
                                                        245,
                                                        -103.496
                                                    ],
                                                    [
                                                        205.191,
                                                        -101.971
                                                    ],
                                                    [
                                                        -203.662,
                                                        -101.971
                                                    ]
                                                ],
                                                "c": true
                                            }
                                        ]
                                    }
                                ],
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "st",
                            "c": {
                                "a": 0,
                                "k": [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                "ix": 3
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 4
                            },
                            "w": {
                                "a": 0,
                                "k": 35,
                                "ix": 5
                            },
                            "lc": 2,
                            "lj": 2,
                            "bm": 0,
                            "nm": "Stroke 1",
                            "mn": "ADBE Vector Graphic - Stroke",
                            "hd": false,
                            "_render": true
                        },
                        {
                            "ty": "tr",
                            "p": {
                                "a": 0,
                                "k": [
                                    375,
                                    235.971
                                ],
                                "ix": 2
                            },
                            "a": {
                                "a": 0,
                                "k": [
                                    0,
                                    0
                                ],
                                "ix": 1
                            },
                            "s": {
                                "a": 0,
                                "k": [
                                    100,
                                    100
                                ],
                                "ix": 3
                            },
                            "r": {
                                "a": 0,
                                "k": 0,
                                "ix": 6
                            },
                            "o": {
                                "a": 0,
                                "k": 100,
                                "ix": 7
                            },
                            "sk": {
                                "a": 0,
                                "k": 0,
                                "ix": 4
                            },
                            "sa": {
                                "a": 0,
                                "k": 0,
                                "ix": 5
                            },
                            "nm": "Transform",
                            "_render": true
                        }
                    ],
                    "nm": "Group 2",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false,
                    "_render": true
                }
            ],
            "ip": 0,
            "op": 20,
            "st": 0,
            "ct": 1,
            "bm": 0,
            "completed": true
        }
    ],
    "markers": [],
    "__complete": true
}